import React from "react";
import { ChevronDown } from "lucide-react";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function Sekcja1Hero() {
  const {
    ref: contentRef,
    isVisible: isContentVisible
  } = useRevealOnScroll();
  return <section data-section-id="62434" id="elite-gaming-gear" className="relative min-h-screen w-full bg-background overflow-hidden flex items-center justify-center dark">
      {}
      <div className="absolute inset-0 z-0">
        <div className="absolute inset-0 bg-black/60 z-10 backdrop-radial from-transparent to-background" />
        <div className="h-full w-full bg-[url(https://wpvc-images.s3.us-east-1.amazonaws.com/images/1630779/img/prophecy_walnut_hero.png)] bg-cover bg-center bg-no-repeat bg-fixed transform scale-105 opacity-40 grayscale-[0.5]" role="img" aria-label="High-performance gaming hardware background" />
        <div className="absolute inset-0 z-15 bg-[linear-gradient(to_right,#ffffff05_1px,transparent_1px),linear-gradient(to_bottom,#ffffff05_1px,transparent_1px)] bg-[size:64px_64px]" />
      </div>

      {}
      <div ref={contentRef} className={`relative z-20 container mx-auto px-4 flex flex-col items-center justify-center text-center transition-all duration-1000 ease-out ${isContentVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-10"}`}>
        <h3 className="text-primary font-bold text-sm tracking-[0.5em] uppercase mb-2">
          apexrig tech
        </h3>
        <h2 className="text-primary/60 text-xs md:text-sm font-bold tracking-[0.4em] uppercase mb-6 drop-shadow-[0_0_8px_rgba(0,255,255,0.3)]">
          Premium Gaming Experience
        </h2>
        <Link to="/">
          <img src="https://legible-hen-1.10web.cloud/wp-content/uploads/2026/04/ApexRig-Tech-logo-3.jpg" data-wvc-srcset="https://legible-hen-1.10web.cloud/wp-content/uploads/2026/04/ApexRig-Tech-logo-3.jpg-wvc-srcset" data-wvc-sizes="https://legible-hen-1.10web.cloud/wp-content/uploads/2026/04/ApexRig-Tech-logo-3.jpg-wvc-sizes" alt="ApexRig Tech Logo" className="w-[300px] h-auto mb-8 drop-shadow-[0_0_20px_rgba(0,255,255,0.5)] filter drop-shadow-lg" style={{
          filter: "drop-shadow(0 0 20px rgba(0, 255, 255, 0.5))"
        }} loading="lazy" />
        </Link>
        <h1 className="font-default font-bold text-5xl md:text-7xl lg:text-[5.5rem] leading-tight bg-clip-text text-transparent bg-gradient-to-r from-primary via-primary to-secondary drop-shadow-[0_0_15px_rgba(0,255,255,0.3)] mb-8 tracking-tighter">
          UNLEASH THE FUTURE
        </h1>
        
        <p className="font-sans text-lg md:text-xl text-foreground/80 max-w-2xl mb-10 font-normal tracking-wide">
          Discover the next generation of high-performance gear. ApexRig Tech brings you curated tech designed for the elite gamer and tech enthusiast.
        </p>
      </div>

      {}
      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 z-20 animate-bounce">
        <Link to="#next-section" aria-label="Scroll down">
          <ChevronDown className="h-10 w-10 text-primary/70 hover:text-primary transition-colors" />
        </Link>
      </div>
    </section>;
}